/* PROJ-67 Besties — Editor-UI.
 * Ablauf:
 *   1. Nur der Anzahl-Picker ist sichtbar (3/5/8).
 *   2. Nach der Wahl klappt der Rest untereinander aus — KEINE Tabs.
 *   3. Upload: Vorschau via objectURL, Original nach S3
 *      (/api/v1/upload/presigned-url/), Crop als normierte Ratios.
 *   4. Cart-Add: /api/v1/blanket/render/ -> /cart/add.js
 *      mit _Provider=gelato + _job_id (Muster foto-decke-collage.js).
 *      PROJ-68: Produzent ist Gelato (Gildan 5000, Rueckendruck gpr_0-4) —
 *      MerchOne kann bei Bekleidung nur vorne drucken.
 */
(function () {
  'use strict';

  var API = window.BESTIES_BACKEND_API_URL;
  var L = window.BESTIES_LAYOUT;
  var P = window.BESTIES_PRESETS;

  // Freitext-Spruch (Ansage Dominik 09.08.): Dropdown-Eintrag + Zeichenlimit.
  // 50 Zeichen = maximal ZWEI volle Zeilen bei Schriftgroesse 62 (Ansage:
  // zwei Reihen, nie drei; 60 ergab im Test drei). Die Engine bricht bei
  // voller Groesse balanciert um; fitQuoteLines verkleinert NUR im
  // Extremfall breiter Glyphen, bis zwei Zeilen reichen.
  var EIGENER_SPRUCH = 'Eigener Spruch …';
  var MAX_QUOTE = 50;

  var state = {
    count: null, theme: 'black', variant_id: null,
    title: { mode: 'preset', value: P.titles[0].label },  // immer Preset, kein Freitext
    quote: P.quotes[0], names: '',
    quoteMode: 'preset',  // 'custom' = Freitext-Spruch (Ansage Dominik 09.08.)
    themeManuell: false,   // Kunde hat Schriftfarbe selbst gewaehlt (08.08.)
    photos: [],  // { url, crop, localPreview } -- zeigt auf den aktiven Satz
    // Fotos gehoeren zur ANZAHL, nicht zum Kunden allgemein. Der Zuschnitt ist
    // gegen das Seitenverhaeltnis genau EINES Rasters gerechnet: rechts sind
    // die Rahmen bei 5 Fotos 900x456, bei 3 Fotos 900x1430. Uebernimmt man den
    // Zuschnitt in ein anderes Raster, bildet die Engine ihn per
    // object-fit:fill auf den neuen Rahmen ab und zieht das Bild lang -- die
    // Bedingung aus dem cropStyle-Kommentar der Engine ist dann verletzt.
    // Getrennte Saetze statt Loeschen: wer zurueckwechselt, findet seine Fotos
    // wieder vor.
    photosByCount: { 1: [], 3: [], 5: [], 8: [] }
  };

  var form = document.getElementById('besties-form');
  var errorEl = document.getElementById('besties-error');

  function h(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }
  /* Beschriftung eines Pflichtfelds: Text plus roter Stern. Im Theme gab es
     dafuer bisher keine Konvention (durchsucht), deshalb hier an EINER Stelle,
     damit die naechste PDP sie uebernehmen kann statt sie neu zu erfinden.
     Der Stern ist aria-hidden, weil die Pflicht fuer Screenreader ueber
     aria-required am Feld selbst transportiert wird -- ein vorgelesenes
     "Sternchen" hilft niemandem. */
  function pflichtLabel(text) {
    var n = h('span', 'besties-field__label', text);
    var s = h('span', 'besties-field__pflicht', '*');
    s.setAttribute('aria-hidden', 'true');
    n.appendChild(s);
    return n;
  }
  function showError(msg) {
    if (!errorEl) return;          // Block noch nicht im DOM
    errorEl.textContent = msg || '';
    errorEl.hidden = !msg;
  }

  // --- Anzahl-Picker: der einzige sichtbare Einstieg ---------------------
  function buildCountPicker() {
    var wrap = h('div', 'besties-field');
    wrap.dataset.feld = 'count';
    wrap.appendChild(pflichtLabel('Anzahl der Fotos'));
    var row = h('div', 'besties-count');
    ['1', '3', '5', '8'].forEach(function (n) {
      var b = h('button', 'besties-count__btn', n);
      b.type = 'button';
      b.addEventListener('click', function () {
        var neueAnzahl = parseInt(n, 10);
        if (state.count === neueAnzahl) return;
        state.count = neueAnzahl;
        state.photos = state.photosByCount[neueAnzahl];
        state.photos.length = Math.max(state.photos.length, neueAnzahl);
        [].forEach.call(row.children, function (c) { c.classList.toggle('is-active', c === b); });
        buildRest();
        // Erst jetzt wandert die Engine-Buehne in die Galerie (vorher
        // zeigen dort die normalen 5:4-Mockups das fertige Design).
        mountStageInGallery();
        window.BestiesEditor.repaint();
      });
      row.appendChild(b);
    });
    wrap.appendChild(row);
    form.appendChild(wrap);
  }

  var restEl = null;

  // --- Bildqualitaet -------------------------------------------------------
  // Formel aus assets/photo.js:1247-1271 uebernommen: zugeschnittene Pixel
  // geteilt durch Zoll, die schwaechere Achse gewinnt.
  //
  // Anders als beim Poster hat hier JEDES Foto seinen eigenen Rahmen, also
  // eine eigene Bewertung -- im Achter-Raster ist ein Rahmen nur 9,9 x 7,7 cm
  // gross, im Dreier-Raster 15,2 x 24,2 cm.
  //
  // Die Schwellen sind bewusst strenger als beim Poster (dort 100/75). Der
  // Poster-Kommentar begruendet seine Werte ausdruecklich mit 1,5 bis 2 m
  // Wandabstand; ein Shirt wird aus einem halben Meter betrachtet, und DTG
  // druckt groeber als Papier. Entscheidung Dominik, 07.08.
  var QUALITAET_SCHWELLEN = { gruen: 150, orange: 100 };
  var DRUCK_CM = { w: 35.56, h: 40.64 };
  var QUALITAET_TEXT = {
    gruen:  { text: 'Ausgezeichnet', pfad: 'M3 7.5l3 3 5-6.5' },
    orange: { text: 'Akzeptabel',    pfad: 'M3 7h8' },
    rot:    { text: 'Niedrig',       pfad: 'M4 4l6 6M10 4l-6 6' }
  };

  function rahmenInCm(index) {
    var f = L.variants[String(state.count)].photos[index];
    return { w: f.w / L.canvas.w * DRUCK_CM.w, h: f.h / L.canvas.h * DRUCK_CM.h };
  }

  // Rechnet gegen die ORIGINALMASSE, nicht gegen die vor dem Cropper
  // verkleinerte Fassung -- sonst waere die Anzeige systematisch zu
  // pessimistisch (siehe pendingOriginalDims-Muster in photo.js:531).
  function qualitaet(foto, index) {
    if (!foto || !foto.natW || !foto.natH) return null;
    var cm = rahmenInCm(index);
    var breitePx = foto.natW * ((foto.crop && foto.crop.w) || 1);
    var hoehePx = foto.natH * ((foto.crop && foto.crop.h) || 1);
    var dpi = Math.min(breitePx / (cm.w / 2.54), hoehePx / (cm.h / 2.54));
    var stufe = dpi >= QUALITAET_SCHWELLEN.gruen ? 'gruen'
              : dpi >= QUALITAET_SCHWELLEN.orange ? 'orange' : 'rot';
    return { stufe: stufe, dpi: Math.round(dpi), cm: cm };
  }

  function zeigeQualitaet(knopf, index) {
    var q = qualitaet(state.photos[index], index);
    if (!q) { knopf.hidden = true; return; }
    var t = QUALITAET_TEXT[q.stufe];
    knopf.hidden = false;
    knopf.dataset.stufe = q.stufe;
    knopf.dataset.dpi = String(q.dpi);
    knopf.innerHTML =
      '<span class="besties-quality__icon" aria-hidden="true">' +
      '<svg width="14" height="14" viewBox="0 0 14 14" fill="none">' +
      '<path d="' + t.pfad + '" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
      '<span class="besties-quality__label">Qualität:</span>' +
      '<span class="besties-quality__status"></span>';
    knopf.querySelector('.besties-quality__status').textContent = t.text;
  }

  // Erklaerfenster. Beim Poster listet es alle Papierformate auf -- hier gibt
  // es nur EINE Druckflaeche, deshalb stattdessen der erreichte Wert und was
  // er bedeutet.
  function oeffneQualitaetsInfo(index) {
    var q = qualitaet(state.photos[index], index);
    if (!q) return;
    var hg = h('div', 'besties-quality-modal');
    var kasten = h('div', 'besties-quality-modal__box');
    var kopf = h('div', 'besties-quality-modal__head');
    kopf.appendChild(h('h3', null, 'Bildqualität'));
    var zu = h('button', 'besties-quality-modal__close', '×');
    zu.type = 'button';
    zu.setAttribute('aria-label', 'Schließen');
    kopf.appendChild(zu);
    kasten.appendChild(kopf);
    kasten.appendChild(h('p', 'besties-quality-modal__intro',
      'Ist die Auflösung deines Fotos zu niedrig, kann der Druck unscharf ' +
      'wirken. Hier siehst du, wie gut dein Foto für diesen Platz reicht.'));
    var liste = h('ul', 'besties-quality-modal__list');
    var zeilen = [
      ['Dieser Fotoplatz', q.cm.w.toFixed(1).replace('.', ',') + ' × ' +
                           q.cm.h.toFixed(1).replace('.', ',') + ' cm'],
      ['Auflösung deines Fotos', q.dpi + ' dpi'],
      ['Ausgezeichnet ab', QUALITAET_SCHWELLEN.gruen + ' dpi'],
      ['Akzeptabel ab', QUALITAET_SCHWELLEN.orange + ' dpi']
    ];
    zeilen.forEach(function (z) {
      var li = h('li');
      li.appendChild(h('span', null, z[0]));
      li.appendChild(h('strong', null, z[1]));
      liste.appendChild(li);
    });
    kasten.appendChild(liste);
    hg.appendChild(kasten);
    document.body.appendChild(hg);
    function schliessen() { hg.remove(); }
    zu.addEventListener('click', schliessen);
    hg.addEventListener('click', function (e) { if (e.target === hg) schliessen(); });
  }

  // --- Upload + Zuschnitt ------------------------------------------------
  // Vorschau sofort via objectURL, Original im Hintergrund nach S3.
  // Der Crop wird als normierte Ratios gespeichert; der Druck nutzt das
  // S3-Original, damit die Aufloesung nicht am Browser des Kunden haengt.
  // Mittiger Ausschnitt im Seitenverhaeltnis des Rahmens, so gross wie moeglich.
  // Gegenstueck zum fill-Vertrag der Engine.
  function defaultCrop(natW, natH, index) {
    var frame = L.variants[String(state.count)].photos[index];
    var target = frame.w / frame.h;
    var imgAR = natW / natH;
    if (imgAR > target) {           // Bild ist breiter -> links und rechts beschneiden
      var w = target / imgAR;
      return { x: (1 - w) / 2, y: 0, w: w, h: 1 };
    }
    var hgt = imgAR / target;       // Bild ist hoeher -> oben und unten beschneiden
    return { x: 0, y: (1 - hgt) / 2, w: 1, h: hgt };
  }

  // Grosse Fotos VOR dem Cropper verkleinern, sonst laeuft Chrome bei 12 bis
  // 48 Megapixeln beim Schieben aus dem Speicher (photo.js:169-197). Die
  // Originalmasse werden getrennt zurueckgegeben, weil die Qualitaetsrechnung
  // gegen sie laufen muss und nicht gegen die verkleinerte Fassung.
  function verkleinereWennNoetig(quelle, maxKante) {
    return new Promise(function (fertig, fehler) {
      var img = new Image();
      img.onload = function () {
        var w = img.naturalWidth, hh = img.naturalHeight;
        if (w <= maxKante && hh <= maxKante) {
          fertig({ url: quelle, natW: w, natH: hh });
          return;
        }
        var s = maxKante / Math.max(w, hh);
        var c = document.createElement('canvas');
        c.width = Math.round(w * s);
        c.height = Math.round(hh * s);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        // JPEG statt PNG: visuell verlustfrei bei Fotos, rund zehnmal kleiner.
        fertig({ url: c.toDataURL('image/jpeg', 0.9), natW: w, natH: hh });
      };
      img.onerror = function () { fehler(new Error('Bild nicht lesbar')); };
      img.src = quelle;
    });
  }

  function buildUploadField(index) {
    var f = h('div', 'besties-field besties-upload');
    f.dataset.feld = 'photo-' + index;
    f.appendChild(pflichtLabel(state.count === 1
      ? 'Dein Foto'
      : 'Foto ' + (index + 1) + ' von ' + state.count));

    var tile = h('div', 'besties-upload__tile');
    var img = h('img', 'besties-upload__thumb'); img.hidden = true;
    var plus = h('div', 'besties-upload__plus', '+');
    tile.appendChild(img); tile.appendChild(plus);

    var input = h('input'); input.type = 'file';
    input.accept = 'image/jpeg,image/png,image/heic,image/heif';
    input.hidden = true;

    // Qualitaetsampel, erscheint erst wenn ein Foto da ist.
    var ampel = h('button', 'besties-quality');
    ampel.type = 'button';
    ampel.hidden = true;
    ampel.addEventListener('click', function () { oeffneQualitaetsInfo(index); });

    // Zwei Knoepfe unter der Miniatur, Muster photo.liquid:158-161.
    // Sichtbarkeit AUSSCHLIESSLICH ueber die Klasse steuern -- die Vorlage
    // blendet per Klasse ein und versteckt per Inline-Stil (photo.js:1862),
    // und weil Inline die Klasse schlaegt, bleibt die Zeile dort nach einem
    // Warenkorb-Zugang unsichtbar.
    var reihe = h('div', 'besties-change-row');
    var neuZuschneiden = h('button', null, 'Neu zuschneiden');
    neuZuschneiden.type = 'button';
    var anderesFoto = h('button', null, 'Anderes Foto');
    anderesFoto.type = 'button';
    reihe.appendChild(neuZuschneiden);
    reihe.appendChild(anderesFoto);

    function nachAenderung() {
      zeigeQualitaet(ampel, index);
      reihe.classList.add('visible');
      window.BestiesEditor.repaint();
    }

    anderesFoto.addEventListener('click', function () { input.click(); });
    neuZuschneiden.addEventListener('click', function () {
      var p = state.photos[index];
      if (!p || !p.bearbeitbar) return;
      openCropper(p.bearbeitbar, index, img, nachAenderung);
    });

    tile.addEventListener('click', function () { input.click(); });
    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      if (!file) return;
      if (file.size > 20 * 1024 * 1024) { showError('Foto ' + (index + 1) + ' ist größer als 20 MB.'); return; }
      showError('');
      var localUrl = URL.createObjectURL(file);
      img.src = localUrl; img.hidden = false; plus.hidden = true;
      // Start-Crop MUSS das Seitenverhaeltnis des Rahmens haben, sonst verzerrt
      // die Engine das Bild (sie rechnet mit fill, siehe cropStyle-Kommentar).
      state.photos[index] = { url: localUrl, crop: null, pending: true };
      verkleinereWennNoetig(localUrl, 2400).then(function (r) {
        var p = state.photos[index];
        if (!p) return;
        p.natW = r.natW;
        p.natH = r.natH;
        p.bearbeitbar = r.url;          // verkleinert, fuer den Cropper
        p.crop = defaultCrop(r.natW, r.natH, index);
        nachAenderung();
        openCropper(r.url, index, img, nachAenderung);
      }).catch(function () {
        showError('Foto ' + (index + 1) + ' konnte nicht gelesen werden.');
      });
      uploadToS3(file, index);
    });

    f.appendChild(tile);
    f.appendChild(ampel);
    f.appendChild(reihe);
    f.appendChild(input);

    // Beim Neu-Bau (Anzahl-Wechsel) den vorhandenen Foto-Zustand
    // wiederherstellen (Ansage Dominik 09.08.): nach 1 -> 3 -> 1 war das
    // Feld leer, obwohl Foto und Zuschnitt im State und in der Vorschau
    // weiterlebten. Miniatur, Qualitaetsampel und die beiden Knoepfe
    // kommen aus dem State zurueck.
    var vorhanden = state.photos[index];
    if (vorhanden && vorhanden.url) {
      img.src = vorhanden.bearbeitbar || vorhanden.url;
      img.hidden = false;
      plus.hidden = true;
      zeigeQualitaet(ampel, index);
      reihe.classList.add('visible');
    }
    return f;
  }

  // Bringt das Zuschnitt-Rechteck vollstaendig ins Bild UND behaelt dabei das
  // Seitenverhaeltnis des Rahmens.
  //
  // Vorher wurden x, y, w und h EINZELN begrenzt. Schob man den Rahmen ueber
  // den Bildrand, wurde zwar x auf 0 gezogen, w blieb aber gross -- das
  // Rechteck ragte aus dem Bild heraus, und die Engine zeigte fuer diesen Teil
  // nichts an: der schwarze Balken. Einzeln zu begrenzen wuerde ausserdem das
  // Seitenverhaeltnis zerstoeren und das Bild verzerren, also derselbe Fehler
  // wie beim Wechsel der Fotoanzahl.
  //
  // Reihenfolge: erst die Groesse ins Bild bringen (verhaeltnistreu), dann die
  // Position so verschieben, dass das Rechteck ganz drin liegt.
  function begrenzeAufBild(d, nat, verhaeltnis) {
    var w = Math.min(d.width, nat.w);
    var hh = w / verhaeltnis;
    if (hh > nat.h) { hh = nat.h; w = hh * verhaeltnis; }
    var x = Math.min(Math.max(d.x, 0), Math.max(0, nat.w - w));
    var y = Math.min(Math.max(d.y, 0), Math.max(0, nat.h - hh));
    return { x: x / nat.w, y: y / nat.h, w: w / nat.w, h: hh / nat.h };
  }

  // --- Zuschnitt-Dialog ----------------------------------------------------
  // Aufbau, Zoom-Logik und Cropper-Optionen aus dem Fotoposter uebernommen
  // (photo.liquid:567-590, photo.js:628-645 und 695-762). Die dortigen
  // Kommentare nennen fuer jede Einstellung einen realen Bug -- deshalb
  // unveraendert mitgenommen.
  //
  // Klassenpraefix besties-crop und NICHT cropper-modal: Cropper.js belegt
  // diese Klasse selbst.
  function openCropper(src, index, thumbEl, fertigCallback) {
    if (typeof window.Cropper === 'undefined') {
      showError('Der Bild-Editor wird noch geladen. Einen Moment bitte.');
      return;
    }
    var hg = h('div', 'besties-cropper');
    var kasten = h('div', 'besties-crop-modal');
    kasten.appendChild(h('h3', null, 'Foto zuschneiden'));

    var buehne = h('div', 'besties-cropper__stage');
    var cimg = h('img');
    buehne.appendChild(cimg);
    kasten.appendChild(buehne);

    kasten.appendChild(h('p', 'besties-cropper__help',
      'Verschiebe den Rahmen oder seine Ecken, um dein Bild zuzuschneiden. ' +
      'Mit Mausrad oder Regler kannst du zoomen.'));

    var zoomLeiste = h('div', 'besties-cropper__zoom');
    var raus = h('button', 'besties-cropper__zoombtn', '−');
    raus.type = 'button'; raus.setAttribute('aria-label', 'Rauszoomen');
    var regler = h('input', 'besties-cropper__slider');
    regler.type = 'range'; regler.min = '100'; regler.max = '200';
    regler.step = '1'; regler.value = '100';
    var rein = h('button', 'besties-cropper__zoombtn', '+');
    rein.type = 'button'; rein.setAttribute('aria-label', 'Reinzoomen');
    zoomLeiste.appendChild(raus); zoomLeiste.appendChild(regler); zoomLeiste.appendChild(rein);
    kasten.appendChild(zoomLeiste);

    var bar = h('div', 'besties-cropper__bar');
    var cancel = h('button', 'besties-cropper__cancel', 'Abbrechen'); cancel.type = 'button';
    var ok = h('button', 'besties-cropper__ok', 'Zuschneiden & übernehmen'); ok.type = 'button';
    bar.appendChild(cancel); bar.appendChild(ok);
    kasten.appendChild(bar);

    hg.appendChild(kasten);
    document.body.appendChild(hg);

    var cropper = null;
    var startVerhaeltnis = null;

    // Seitenverhaeltnis am DOM MESSEN statt rechnen. Der Fotoplatz traegt es
    // bereits, und gemessen kann es nicht vom Layout abdriften.
    var platz = document.querySelector('[data-slot="photo' + (index + 1) + '"]');
    var r = platz && platz.getBoundingClientRect();
    var frame = L.variants[String(state.count)].photos[index];
    var verhaeltnis = (r && r.height > 0) ? (r.width / r.height) : (frame.w / frame.h);

    // Einmal-Sperre plus complete-Pruefung, Pflicht-Muster aus
    // features/editor-ui-konventionen.md Punkt 1: onload feuert NICHT
    // zuverlaessig, wenn das Bild schon im Speicher liegt -- und genau das ist
    // hier der Fall, weil verkleinereWennNoetig dasselbe Blob vorher geladen
    // hat. Ohne die complete-Pruefung entstand der Cropper mal und mal nicht.
    // Ohne die Sperre entstuenden dafuer ZWEI, und der zweite ist kaputt.
    var cropperGebaut = false;
    function baueCropper() {
      if (cropperGebaut) return;
      cropperGebaut = true;
      // Init im naechsten Frame: der Umschalter auf sichtbar ist synchron,
      // der Layout-Reflow kommt erst danach. Sonst misst Cropper 0x0.
      //
      // Aber NICHT allein auf requestAnimationFrame verlassen: der Browser
      // pausiert es in nicht sichtbaren Tabs. Wechselt der Kunde den Tab,
      // waehrend er ein Foto waehlt, bliebe der Zuschnitt sonst tot -- im
      // Test genau so aufgetreten. Deshalb ein Wecker als Netz.
      var initGelaufen = false;
      function initJetzt() {
        if (initGelaufen) return;
        initGelaufen = true;
        cropper = new window.Cropper(cimg, {
          aspectRatio: verhaeltnis,
          viewMode: 1,
          autoCropArea: 1,
          movable: true,
          zoomable: true,
          rotatable: false,
          scalable: false,
          cropBoxResizable: true,
          dragMode: 'none',      // Zug ausserhalb der Box zog eine neue Mini-Box auf (Clarity 10.08.)
          toggleDragModeOnDblclick: false,
          minCropBoxWidth: 60,   // keine Winz-Box, auch nicht ueber die Ecken
          minCropBoxHeight: 60,
          responsive: false,     // sonst reisst die iOS-Adressleiste den Zug ab
          background: false,     // sonst teurer Repaint pro Zug-Frame
          modal: true,
          wheelZoomRatio: 0.08,
          ready: function () {
            var cd = cropper.getCanvasData();
            startVerhaeltnis = cd.naturalWidth ? (cd.width / cd.naturalWidth) : null;
            regler.value = 100;
            requestAnimationFrame(function () {
              try { cropper.resize(); } catch (e) {}
            });
          },
          zoom: function (ev) {
            if (!startVerhaeltnis) return;
            // Ein Deckel fuer alle drei Eingabewege: Regler, Knoepfe, Mausrad.
            var min = startVerhaeltnis, max = startVerhaeltnis * 2;
            if (ev.detail.ratio < min || ev.detail.ratio > max) {
              ev.preventDefault();
              return;
            }
            regler.value = Math.max(100, Math.min(200,
              Math.round((ev.detail.ratio / startVerhaeltnis) * 100)));
          }
        });
      }
      requestAnimationFrame(initJetzt);
      setTimeout(initJetzt, 300);
    }
    cimg.onload = baueCropper;
    cimg.onerror = function () {
      showError('Das Foto konnte nicht geladen werden.');
      hg.remove();
    };
    cimg.src = src;
    if (cimg.complete && cimg.naturalWidth) baueCropper();

    regler.addEventListener('input', function () {
      if (!cropper || !startVerhaeltnis) return;
      cropper.zoomTo(startVerhaeltnis * (parseInt(this.value, 10) / 100));
    });
    rein.addEventListener('click', function () { if (cropper) cropper.zoom(0.1); });
    raus.addEventListener('click', function () { if (cropper) cropper.zoom(-0.1); });

    function schliessen() {
      if (cropper) { try { cropper.destroy(); } catch (e) {} }
      hg.remove();
    }
    cancel.addEventListener('click', schliessen);

    // Nur schliessen, wenn Druck UND Loslassen auf dem Hintergrund lagen.
    // Sonst verschluckt ein Zug-Ende, das aus der Crop-Box heraus auf den
    // Hintergrund faellt, das Loslassen -- Dialog geht zu und die Crop-Box
    // haengt (photo.js:605-626, realer Fehlerbericht).
    var zugAufHintergrund = false;
    hg.addEventListener('pointerdown', function (e) { zugAufHintergrund = (e.target === hg); });
    hg.addEventListener('pointerup', function (e) {
      var zu = zugAufHintergrund && e.target === hg;
      zugAufHintergrund = false;
      if (zu) schliessen();
    });

    ok.addEventListener('click', function () {
      if (!cropper) return;
      var d = cropper.getData(true);
      var nat = { w: cimg.naturalWidth, h: cimg.naturalHeight };
      var c = begrenzeAufBild(d, nat, verhaeltnis);
      state.photos[index].crop = c;

      // Den begrenzten Ausschnitt in den Cropper zurueckschreiben, BEVOR die
      // Miniatur entsteht. Sonst schneidet getCroppedCanvas nach dem
      // urspruenglichen, moeglicherweise ueberstehenden Rahmen -- Miniatur und
      // Vorschau zeigten dann Verschiedenes.
      try {
        cropper.setData({
          x: c.x * nat.w, y: c.y * nat.h,
          width: c.w * nat.w, height: c.h * nat.h
        });
      } catch (e) { /* Miniatur ist Beiwerk */ }
      // Miniatur aus dem Zuschnitt. Faellt sie aus (getaintes Canvas bei
      // fremder Herkunft), bleibt der Zuschnitt trotzdem gueltig.
      try {
        // fillColor ist PFLICHT: Bereiche ausserhalb des Bildes kommen aus
        // getCroppedCanvas transparent zurueck, und JPEG kennt keine
        // Transparenz -- daraus wird SCHWARZ. Genau das war der schwarze
        // Balken, den Dominik nach dem Verschieben gesehen hat.
        thumbEl.src = cropper.getCroppedCanvas({
          width: 240,
          fillColor: '#ffffff',
          imageSmoothingEnabled: true,
          imageSmoothingQuality: 'high'
        }).toDataURL('image/jpeg', 0.85);
        thumbEl.hidden = false;
      } catch (e) { /* Miniatur ist Beiwerk, kein Grund abzubrechen */ }
      schliessen();
      if (fertigCallback) fertigCallback();
    });
  }

  // Presign-Vertrag gegen foto-decke-collage.js:1157-1174 verifiziert (echter
  // Backend-Endpoint): Antwort liefert wahlweise camelCase oder snake_case,
  // dazu optionale `fields` fuer einen S3-Presigned-POST (nicht PUT). Beides
  // hier uebernehmen statt den einfacheren PUT-Fall zu erfinden, sonst
  // schlaegt der Upload gegen den echten Server fehl.
  function uploadToS3(file, index) {
    fetch(API + '/api/v1/upload/presigned-url/', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename: file.name, content_type: file.type || 'image/jpeg' })
    })
      .then(function (r) { if (!r.ok) throw new Error('presign ' + r.status); return r.json(); })
      .then(function (presigned) {
        var uploadUrl = presigned.uploadUrl || presigned.upload_url;
        var publicUrl = presigned.publicUrl || presigned.public_url;
        var fields = presigned.fields || {};
        if (!uploadUrl || !publicUrl) throw new Error('presign: ungültige Antwort');
        var formData = new FormData();
        Object.keys(fields).forEach(function (k) { formData.append(k, fields[k]); });
        formData.append('file', file);
        return fetch(uploadUrl, { method: 'POST', body: formData })
          .then(function (r) { if (!r.ok && r.status !== 204) throw new Error('put ' + r.status); return publicUrl; });
      })
      .then(function (publicUrl) {
        state.photos[index].url = publicUrl;
        state.photos[index].pending = false;
        // repaint MUSS auch hier laufen: Task 5 haengt Lade- und Fehleranzeigen
        // der Kacheln an state.photos[i].pending. Ohne den Aufruf bleibt eine
        // Kachel optisch fuer immer im Ladezustand haengen.
        window.BestiesEditor.repaint();
      })
      .catch(function (e) {
        console.error('[besties] Upload fehlgeschlagen', e);
        state.photos[index].pending = 'error';
        showError('Foto ' + (index + 1) + ' konnte nicht hochgeladen werden. Bitte erneut versuchen.');
        window.BestiesEditor.repaint();
      });
  }

  // --- Der Rest, klappt erst nach der Anzahl-Wahl auf --------------------
  // Custom-Dropdown statt nativem <select>: das aufgeklappte System-Menue
  // laesst sich per CSS nicht stylen (Ansage Dominik 08.08., PetPrinted-
  // Look). Button + eigene Optionsliste; Escape/Klick-draussen schliesst.
  var offenesDropdown = null;
  function schliesseDropdown() {
    if (!offenesDropdown) return;
    offenesDropdown.querySelector('.besties-dd__liste').hidden = true;
    var b = offenesDropdown.querySelector('.besties-dd__btn');
    b.classList.remove('is-open');
    b.setAttribute('aria-expanded', 'false');
    offenesDropdown = null;
  }
  document.addEventListener('click', function (e) {
    if (offenesDropdown && !offenesDropdown.contains(e.target)) schliesseDropdown();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') schliesseDropdown();
  });
  function baueDropdown(werte, startWert, onChange) {
    var wrap = h('div', 'besties-dd');
    var btn = h('button', 'besties-dd__btn', startWert);
    btn.type = 'button';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var liste = h('ul', 'besties-dd__liste');
    liste.hidden = true;
    liste.setAttribute('role', 'listbox');
    werte.forEach(function (w) {
      var li = h('li', 'besties-dd__opt', w);
      li.setAttribute('role', 'option');
      if (w === startWert) li.classList.add('is-selected');
      li.addEventListener('click', function () {
        btn.textContent = w;
        liste.querySelectorAll('.is-selected').forEach(function (x) { x.classList.remove('is-selected'); });
        li.classList.add('is-selected');
        schliesseDropdown();
        onChange(w);
      });
      liste.appendChild(li);
    });
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var warOffen = !liste.hidden;
      schliesseDropdown();
      if (!warOffen) {
        liste.hidden = false;
        // Flip: reicht der Platz unterm Button nicht, klappt die Liste nach
        // oben auf; die Hoehe passt sich dem verfuegbaren Platz an, damit
        // nichts unter der Viewport-Kante verschwindet (Ansage 08.08.).
        var r = btn.getBoundingClientRect();
        var platzUnten = window.innerHeight - r.bottom - 16;
        var platzOben = r.top - 16;
        var wunschHoehe = Math.min(liste.scrollHeight + 12, 280);
        var nachOben = platzUnten < wunschHoehe && platzOben > platzUnten;
        liste.classList.toggle('besties-dd__liste--oben', nachOben);
        liste.style.maxHeight = Math.max(160, Math.min(280, nachOben ? platzOben : platzUnten)) + 'px';
        btn.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        offenesDropdown = wrap;
      }
    });
    wrap.appendChild(btn);
    wrap.appendChild(liste);
    return wrap;
  }

  // Schriftfarbe-Kacheln markieren: gewaehlt ist die Kachel, deren
  // SCHRIFT-Farbe gerade gilt (theme 'black' = dunkles Shirt = weisse Schrift).
  function syncInkWahl() {
    var schrift = state.theme === 'black' ? 'white' : 'black';
    document.querySelectorAll('.besties-ink').forEach(function (b) {
      b.classList.toggle('is-selected', b.dataset.schrift === schrift);
    });
  }

  function buildRest() {
    if (restEl) restEl.remove();
    restEl = h('div', 'besties-rest');

    // Schriftfarbe: manuell waehlbar (Ansage Dominik 08.08., PetPrinted-
    // Muster: zwei Kacheln mit Haekchen-Ecke). Der Default folgt weiter der
    // Stofffarbe, bis der Kunde selbst waehlt (themeManuell).
    var ink = h('div', 'besties-field');
    ink.appendChild(h('span', 'besties-field__label', 'Schriftfarbe'));
    var inkWahl = h('div', 'besties-inkwahl');
    [['white', 'Weiß'], ['black', 'Schwarz']].forEach(function (paar) {
      var b = h('button', 'besties-ink besties-ink--' + paar[0]);
      b.type = 'button';
      b.dataset.schrift = paar[0];
      b.setAttribute('aria-label', 'Schriftfarbe ' + paar[1]);
      b.addEventListener('click', function () {
        // Kachel zeigt die SCHRIFT-Farbe; theme ist nach Stoff benannt:
        // weisse Schrift = 'black'-Design, schwarze Schrift = 'white'-Design.
        state.theme = paar[0] === 'white' ? 'black' : 'white';
        state.themeManuell = true;
        syncInkWahl();
        window.BestiesEditor.repaint();
      });
      inkWahl.appendChild(b);
    });
    ink.appendChild(inkWahl);
    restEl.appendChild(ink);
    syncInkWahl();

    // Titel: ausschliesslich Auswahl. Die Titel sind je Anlass fest gesetzt
    // (Paar, Schwester, beste Freundin ...) und kommen aus besties-presets.js.
    // Bewusst KEIN Freitext: die Titel sind gestaltete Typo, freier Text wuerde
    // die Optik brechen. Personalisiert wird ueber die Namen.
    var tf = h('div', 'besties-field');
    tf.dataset.feld = 'titel';
    tf.appendChild(pflichtLabel('Titel'));
    var titelWerte = P.titles.map(function (t) { return t.label; });
    tf.appendChild(baueDropdown(titelWerte, state.title.value || titelWerte[0], function (w) {
      state.title = { mode: 'preset', value: w };
      window.BestiesEditor.repaint();
    }));
    restEl.appendChild(tf);

    // Upload-Felder direkt nach dem Titel — Spruch und Namen stehen ganz
    // unten (Ansage Dominik 08.08.).
    for (var i = 0; i < state.count; i++) restEl.appendChild(buildUploadField(i));

    // Spruch: ebenfalls nur Auswahl. Freitext ist bewusst nicht vorgesehen --
    // die Zeile ist typografisch gesetzt und ein beliebiger Text bricht sie.
    // Falls spaeter doch Freitext gewuenscht ist: Option ergaenzen UND die
    // Wortsperrpruefung in validate() greift bereits dafuer.
    // Namen VOR dem Spruch (Ansage Dominik 08.08.), mit Zeichen-Zaehler.
    var nf = h('div', 'besties-field');
    nf.dataset.feld = 'names';
    // Beschriftung und Beispiel kommen aus dem Anlass: beim Papa-Shirt
    // stehen dort die Namen der Kinder, nicht "Eure Namen".
    var nKopf = h('div', 'besties-field__kopf');
    nKopf.appendChild(pflichtLabel(P.namesLabel || 'Eure Namen'));
    var zaehler = h('span', 'besties-zaehler', '0/' + P.maxNamesChars);
    zaehler.setAttribute('aria-live', 'polite');
    nKopf.appendChild(zaehler);
    nf.appendChild(nKopf);
    var ninput = h('input', 'besties-input');
    ninput.type = 'text'; ninput.maxLength = P.maxNamesChars;
    ninput.placeholder = P.namesPlaceholder || 'Marie & Lena';
    ninput.addEventListener('input', function () {
      state.names = ninput.value;
      zaehler.textContent = ninput.value.length + '/' + P.maxNamesChars;
      window.BestiesEditor.repaint();
    });
    ninput.setAttribute('aria-required', 'true');
    nf.appendChild(ninput);
    restEl.appendChild(nf);

    // Spruch: Auswahl ODER Freitext (Ansage Dominik 09.08.). Die Option
    // "Eigener Spruch" blendet darunter ein Textfeld mit Zeichen-Zaehler ein,
    // gleiches Muster wie die Namen. Freitext-Limit 50 = zwei volle Zeilen,
    // die Engine bricht bei voller Schriftgroesse um (balance, kein Shrink).
    // Wortsperre/Zeichensatz prueft validate() clientseitig UND der Server
    // (_besties_check_text) fuer state.quote sowieso.
    var qf = h('div', 'besties-field');
    qf.dataset.feld = 'spruch';
    var qKopf = h('div', 'besties-field__kopf');
    qKopf.appendChild(pflichtLabel('Spruch'));
    var qZaehler = h('span', 'besties-zaehler',
      (state.quoteMode === 'custom' ? String(state.quote || '').length : 0) + '/' + MAX_QUOTE);
    qZaehler.setAttribute('aria-live', 'polite');
    qZaehler.hidden = state.quoteMode !== 'custom';
    qKopf.appendChild(qZaehler);
    qf.appendChild(qKopf);
    var qInput = h('input', 'besties-input besties-input--spruch');
    qInput.type = 'text'; qInput.maxLength = MAX_QUOTE;
    qInput.placeholder = 'Dein eigener Spruch';
    qInput.hidden = state.quoteMode !== 'custom';
    if (state.quoteMode === 'custom') qInput.value = state.quote || '';
    qInput.addEventListener('input', function () {
      state.quote = qInput.value;
      qZaehler.textContent = qInput.value.length + '/' + MAX_QUOTE;
      window.BestiesEditor.repaint();
    });
    var qWerte = P.quotes.slice();
    qWerte.push(EIGENER_SPRUCH);
    var qStart = state.quoteMode === 'custom' ? EIGENER_SPRUCH : (state.quote || P.quotes[0]);
    qf.appendChild(baueDropdown(qWerte, qStart, function (w) {
      if (w === EIGENER_SPRUCH) {
        state.quoteMode = 'custom';
        state.quote = qInput.value || '';
        qInput.hidden = false;
        qZaehler.hidden = false;
        qZaehler.textContent = String(state.quote).length + '/' + MAX_QUOTE;
        qInput.focus();
      } else {
        state.quoteMode = 'preset';
        state.quote = w;
        qInput.hidden = true;
        qZaehler.hidden = true;
      }
      window.BestiesEditor.repaint();
    }));
    qf.appendChild(qInput);
    restEl.appendChild(qf);

    form.appendChild(restEl);
    syncInkWahl();
  }

  window.BestiesEditor = {
    state: state,
    getConfig: function () {
      return {
        count: state.count, theme: state.theme,
        title: { mode: state.title.mode, value: state.title.value },
        quote: state.quote, names: state.names,
        photos: state.photos.slice(0, state.count).map(function (p) {
          // Ohne gueltigen Zuschnitt KEIN Bild durchreichen: die Engine wuerde
          // es mit dem Ersatz-Rechteck {0,0,1,1} auf den Rahmen ziehen. Lieber
          // kurz den grauen Platzhalter zeigen als ein verzerrtes Foto.
          var brauchbar = p && p.url && p.crop && p.crop.w > 0 && p.crop.h > 0;
          return brauchbar ? { url: p.url, crop: p.crop } : { url: null, crop: null };
        }),
        assetBase: window.BESTIES_ASSET_BASE || ''
      };
    },
    repaint: function () {
      var root = document.getElementById('besties-preview');
      var cfg;
      if (!state.count) {
        var stEl = document.querySelector('[data-besties-stage]');
        if (!stEl || !stEl.closest || stEl.closest('[data-besties-stage-source]')) return;
        // Noch keine Anzahl gewaehlt: die Galerie zeigt das FERTIGE
        // Beispiel-Mockup (Ansage Dominik 09.08.) — mit den echten
        // Beispiel-Fotos, nicht mit grauen Platzhalter-Kacheln. Ein blankes
        // Shirt wuerde Kunden verwirren. Die Personalisierung bleibt dabei
        // zu; erst der Klick auf 3/5/8 startet den echten Konfigurator.
        // Gekauft werden kann das Beispiel nie: validate() verlangt count.
        var basis = window.BESTIES_ASSET_BASE || '';
        cfg = {
          count: 3, theme: state.theme,
          title: { mode: 'preset', value: P.titles[0].label },
          quote: P.quotes[0],
          names: P.namesPlaceholder || 'Marie & Lena',
          // crops: cover-Zuschnitt der drei Beispiel-Assets (1000x1339 hoch,
          // 2x 1000x746 quer) auf die 3er-Slots 900x1430 / 900x700.
          photos: [
            { url: basis + 'besties-beispiel-1.jpg', crop: { x: 0.079, y: 0, w: 0.842, h: 1 } },
            { url: basis + 'besties-beispiel-2.jpg', crop: { x: 0.021, y: 0, w: 0.958, h: 1 } },
            { url: basis + 'besties-beispiel-3.jpg', crop: { x: 0.021, y: 0, w: 0.958, h: 1 } }
          ],
          assetBase: basis
        };
      } else {
        cfg = window.BestiesEditor.getConfig();
        // Vorschau zeigt die Beispiel-Namen, bis der Kunde tippt (Ansage
        // 08.08.) — gedruckt wird der Platzhalter NIE: validate() verlangt
        // echte Namen, und der Kauf-Payload nutzt getConfig() direkt.
        if (!String(cfg.names || '').trim()) cfg.names = P.namesPlaceholder || 'Marie & Lena';
      }
      var r;
      try {
        r = window.renderBestiesDesign(root, cfg, L);
      } catch (e) {
        console.error('[besties] Render fehlgeschlagen', e);
        return;
      }
      // fontsReady statt document.fonts.ready: siehe Begruendung in der Engine.
      r.fontsReady().then(function () { r.fitText(); });
      // Zentral hier, nicht an jedem Eingabefeld: JEDE Aenderung geht durch
      // repaint, damit kann die Statuszeile nicht hinterherhinken. Vorher
      // stand nach der Fotoauswahl noch "Bitte waehle zuerst die Anzahl".
      updateStatus();
      if (fehlerAktiv) markiereFehler(false);
    },
    showError: showError
  };

  // ========================================================================
  // Anbindung an die PDP. Muster von den Koordinaten-Produkten
  // (koordinaten-apparel.js), aber mit EIGENEM CSS -- starmap.css ist das
  // Geruest fuer Editoren auf eigener Seite und hat auf einer PDP nichts
  // verloren (Entscheidung Dominik, 07.08.).
  //
  //  Buy Box   : nur Knopf + Statuszeile
  //  Dialog    : Buehne links, Felder rechts
  //  Galerie   : Buehne liegt auf dem Flatlay der aktiven Variante
  //  Warenkorb : Theme-Formular, Konfiguration als properties[...]
  // ========================================================================

  var TEXTS = window.BESTIES_TEXTS || {};
  var VARIANTS = window.BESTIES_VARIANTS || {};

  // Unberuehrte Kopie der Buehne. Bei productChange (Combined Listing) ersetzt
  // das Theme den kompletten Produktbereich samt Galerie -- die eingehaengte
  // Buehne wird dabei zerstoert, und variant:change feuert nicht. Genau diese
  // Verdopplung/Zerstoerung hat bei den Koordinaten-Produkten auf Live schon
  // zugeschlagen (Wiki: koordinaten-apparel, PROJ-28). Ohne Sicherungskopie
  // gaebe es danach keinen Weg zurueck.
  var buehneVorlage = null;

  function stageEl() {
    var vorhandene = document.querySelectorAll('[data-besties-stage]');
    // Mehr als eine heisst: ein Rerender hat dupliziert. Ueberzaehlige weg,
    // sonst rendert die Engine in die falsche und die Vorschau friert ein.
    for (var i = 1; i < vorhandene.length; i++) vorhandene[i].remove();
    if (vorhandene.length) return vorhandene[0];
    // Buehne ist weg -- aus der Vorlage neu einsetzen.
    if (buehneVorlage) {
      var frisch = buehneVorlage.cloneNode(true);
      var quelle = document.querySelector('[data-besties-stage-source]');
      (quelle || document.body).appendChild(frisch);
      return frisch;
    }
    return null;
  }
  function ctaEl() { return document.querySelector('[data-besties-cta]'); }

  // --- Bedienfeld in der Buy Box ------------------------------------------
  // Kein eigenes Fenster: die Felder klappen dort auf, wo der Kunde ohnehin
  // steht, und das Galeriebild aendert sich live mit (Muster Teeinblue).
  // form und errorEl zeigen anfangs auf nichts, weil der Block sie erst
  // ausgibt -- hier verbindlich setzen, BEVOR buildCountPicker() laeuft.
  // NICHT einmalig beim Laden binden. Das Theme rendert Sections teils
  // nachtraeglich (Theme-Editor, Section-Rendering-API) -- dann waeren alle
  // drei leer, buildCountPicker() wuerde an form.appendChild abstuerzen und
  // der Gestalten-Knopf reagierte auf gar nichts. Genau das ist passiert.
  var panel = null;

  function bindeBlock() {
    panel = document.querySelector('[data-besties-panel]');
    form = document.getElementById('besties-form');
    errorEl = document.getElementById('besties-error');
    if (panel) panel.hidden = false;
    return !!(panel && form && errorEl);
  }

  var initVersuche = 0;
  function initBlock() {
    if (!bindeBlock()) {
      if (initVersuche++ < 40) setTimeout(initBlock, 250);
      else console.warn('[besties] Block nicht im DOM gefunden, Editor bleibt aus');
      return;
    }
    initVersuche = 0;
    if (form.childElementCount === 0) buildCountPicker();
    var st = document.querySelector('[data-besties-stage]');
    if (st && !buehneVorlage) buehneVorlage = st.cloneNode(true);
    // Stage NICHT beim Laden mounten (Ansage Dominik 09.08., zweite
    // Iteration): die Galerie zeigt anfangs die normalen 5:4-Mockups, die
    // das Design ohnehin fertig zeigen. Die Engine-Buehne kommt erst, wenn
    // der Kunde die Anzahl waehlt (Mount im Count-Klick-Handler).
    if (state.count) { mountStageInGallery(); window.BestiesEditor.repaint(); }
    // Accordions UNTER den Buybox-Kasten: der Rahmen liegt per :has()-Trick
    // auf der GANZEN .product-info__block-list (apparel-buybox-block.liquid),
    // alles in der Liste steht also IM Kasten. Die vier Accordions gehoeren
    // unter den Kasten, aber in der Spalte (Ansage Dominik 09.08.) — deshalb
    // aus der Liste heraus direkt dahinter verschieben.
    var blockListe = document.querySelector('.product-info__block-list');
    if (blockListe && blockListe.parentNode && !document.querySelector('.besties-akkordeons-nach-kasten')) {
      var akkordeons = blockListe.querySelectorAll('.product-info__block-item[data-block-type="accordion"]');
      if (akkordeons.length) {
        var halter = document.createElement('div');
        halter.className = 'besties-akkordeons-nach-kasten';
        for (var ai = 0; ai < akkordeons.length; ai++) halter.appendChild(akkordeons[ai]);
        blockListe.parentNode.insertBefore(halter, blockListe.nextSibling);
      }
    }
    startVarianteSuchen();
    updateStatus();
  }

  // Der Theme-Editor baut Sections neu auf, ohne die Seite zu laden. Ohne das
  // hier waere der Editor nach jeder Aenderung im Editor tot.
  document.addEventListener('shopify:section:load', function () {
    initVersuche = 0;
    initBlock();
  });

  // Das Panel steht dauerhaft offen -- es gibt keinen Einstiegsknopf mehr.
  // openDialog bleibt als Name erhalten, weil mehrere Stellen es aufrufen,
  // wenn beim Absenden etwas fehlt: dann soll die Bedienung sichtbar sein und
  // hingescrollt werden, nicht aufklappen.
  function openDialog() {
    if (!panel) return;
    panel.hidden = false;
    if (panel.scrollIntoView) panel.scrollIntoView({ block: 'nearest' });
    window.BestiesEditor.repaint();
  }

  function closeDialog() { updateStatus(); }



  // --- Vorschau in der Galerie ---------------------------------------------
  // Die Buehne bringt ihr EIGENES Flatlay mit, deshalb wird das Bild der
  // Kachel darunter verborgen statt durchscheinen zu lassen. Sonst haenge die
  // Kalibrierung daran, wie das Theme die Kachel gerade skaliert.
  function activeSlide() {
    if (state.mediaId) {
      var exact = document.querySelector(
        '.product-gallery__media[data-media-id="' + state.mediaId + '"]');
      if (exact) return exact;
    }
    return document.querySelector('.product-gallery__media[data-variant-media="true"]');
  }

  var galleryTries = 0;
  function mountStageInGallery() {
    var st = stageEl();
    if (!st) return;
    var slide = activeSlide();
    if (!slide) {
      // Galerie kann noch nicht im DOM sein. Begrenzt versuchen, nicht ewig.
      // Zaehler zuruecksetzen, sonst hat jeder spaetere Aufruf nur noch genau
      // einen Versuch und die Buehne findet nie mehr zurueck.
      if (galleryTries++ < 20) setTimeout(mountStageInGallery, 250);
      else galleryTries = 0;
      return;
    }
    galleryTries = 0;
    if (st.parentNode !== slide) {
      // Alten Traeger freigeben, sonst blieben nach einem Farbwechsel im
      // fixierten Modus ZWEI Kacheln sichtbar.
      var alt = document.querySelector('.product-gallery__media.besties-slide');
      if (alt && alt !== slide) alt.classList.remove('besties-slide');
      slide.classList.add('besties-slide');
      slide.appendChild(st);
    }
    fixiereGalerie(slide);
  }

  // FamWalls-Muster (Ansage Dominik 10.08.): Sobald die Personalisierung
  // laeuft (Anzahl gewaehlt, Buehne in der Galerie), zeigt die Galerie NUR
  // noch die Konfigurations-Kachel — jeder Bildwechsel wuerde die
  // Live-Vorschau verstecken. Vorher bleibt die Galerie frei browsbar.
  // Aufhebung gibt es nicht: die Anzahl laesst sich nicht abwaehlen.
  function fixiereGalerie(slide) {
    var root = slide.closest('.product-gallery');
    if (root) root.classList.add('besties-galerie-fixiert');
    var scroller = slide.closest('.product-gallery__carousel');
    if (scroller) scroller.scrollLeft = 0;
  }


  // --- Variante ------------------------------------------------------------
  function applyVariant(v) {
    if (!v) return;
    var meta = VARIANTS[String(v.id)] || {};
    var farbe = String(meta.color || v.option1 || '').toLowerCase();
    // Vier Farben seit 08.08.: colorToken ist der Gelato-Farbtoken (bestimmt
    // Flatlay + bestellte Farbe), theme bleibt die DESIGN-Entscheidung —
    // dunkle Schrift auf allen hellen Stoffen, helle nur auf Schwarz.
    var neuerToken = /pink|rosa/.test(farbe) ? 'light-pink'
                   : /ash|grau/.test(farbe) ? 'ash'
                   : /wei|white/.test(farbe) ? 'white' : 'black';
    // Automatik hat beim STOFFWECHSEL Vorrang (Ansage Dominik 08.08.):
    // weisse Schrift auf weissem Shirt darf nie stehen bleiben. Die manuelle
    // Wahl gilt deshalb nur bis zum naechsten Farbwechsel.
    if (neuerToken !== state.colorToken || !state.themeManuell) {
      state.theme = neuerToken === 'black' ? 'black' : 'white';
      state.themeManuell = false;
    }
    state.colorToken = neuerToken;
    syncInkWahl();
    state.size = String(meta.size || v.option2 || '').toLowerCase();
    state.variant_id = String(v.id);

    var st = stageEl();
    if (st) {
      var treffer = false;
      st.querySelectorAll('[data-flatlay]').forEach(function (img) {
        var passt = img.getAttribute('data-flatlay') === state.colorToken;
        img.hidden = !passt;
        if (passt) treffer = true;
      });
      if (!treffer) {
        var fallback = st.querySelector('[data-flatlay="' + state.theme + '"]');
        if (fallback) fallback.hidden = false;
      }
    }
    farbSwatchMinis();
    if (v.featured_media && v.featured_media.id) state.mediaId = String(v.featured_media.id);

    if (state.count) mountStageInGallery();
    window.BestiesEditor.repaint();
    updateStatus();
  }

  // Miniatur des Kleidungsstuecks im Farb-Picker (Ansage Dominik 08.08.):
  // --swatch-background = Varianten-Flatlay der Farbe (Muster
  // forceSwatchImages in koordinaten-apparel.js; Prestige rendert sonst
  // nur einen Farbklecks).
  function farbSwatchMinis() {
    var meta = window.BESTIES_VARIANTS || {};
    var byColor = {};
    Object.keys(meta).forEach(function (id) {
      var m = meta[id];
      if (m && m.color && m.img && !byColor[m.color]) byColor[m.color] = m.img;
    });
    document.querySelectorAll('.color-swatch').forEach(function (sw) {
      var label = (sw.getAttribute('aria-label')
        || (sw.previousElementSibling && sw.previousElementSibling.value)
        || sw.dataset.value || '').toLowerCase();
      if (!label) return;
      var u = byColor[label];
      if (u) sw.style.setProperty('--swatch-background', 'url("' + u + '")');
    });
  }

  document.addEventListener('variant:change', function (e) {
    applyVariant(e.detail && e.detail.variant);
    setTimeout(farbSwatchMinis, 150);
    setTimeout(farbSwatchMinis, 400);
  });

  // Beim Laden feuert variant:change nicht, und unser Block steht im Markup VOR
  // Varianten-Picker und Kaufknopf -- zum Zeitpunkt des Skripts existiert das
  // Formular also womoeglich noch gar nicht. Blieb variant_id dann leer, tat der
  // Kaufknopf spaeter sichtbar nichts. Deshalb: mehrfach nachfassen.
  function initialVariant() {
    var s = document.querySelector('script[data-variant]');
    if (s) {
      try {
        var v = JSON.parse(s.textContent);
        if (v && v.id) return v;
      } catch (err) {}
    }
    var f = themeForm();
    var idInput = f && f.querySelector('[name="id"]');
    if (idInput && idInput.value) return { id: idInput.value };
    return null;
  }

  var variantVersuche = 0;
  function startVarianteSuchen() {
    if (state.variant_id) return;
    var v = initialVariant();
    if (v) { applyVariant(v); return; }
    if (variantVersuche++ < 20) setTimeout(startVarianteSuchen, 250);
  }

  // --- Statuszeile und Kaufsperre ------------------------------------------
  // Meldungen, die nichts mit der Gestaltung zu tun haben (z. B. fehlende
  // Groesse), gehoeren an den Kaufknopf und nicht in den Dialog.
  function zeigeHinweisAmKnopf(text) {
    var cta = ctaEl();
    var out = cta && cta.querySelector('[data-besties-status]');
    if (!out) return;
    out.textContent = text;
    out.classList.remove('is-ok');
  }

  function updateStatus() {
    var cta = ctaEl();
    var out = cta && cta.querySelector('[data-besties-status]');
    // Fuer den Status zaehlt nur die Gestaltung. Die Variante waehlt der Kunde
    // im Picker daneben, die gehoert nicht in diese Meldung.
    var problem = validate({ ohneVariante: true });
    if (out) {
      // Nur der schlichte Status. Die konkrete Fehlermeldung steht im Panel
      // (#besties-error) -- vorher stand derselbe Satz doppelt da (Ansage
      // Dominik 09.08., Screenshot).
      out.textContent = problem ? (TEXTS.leer || 'Noch nicht gestaltet') : (TEXTS.fertig || 'Gestaltet');
      out.classList.toggle('is-ok', !problem);
    }
    if (cta) cta.classList.toggle('is-ok', !problem);
  }

  // --- Theme-Formular ------------------------------------------------------
  // Auf einer PDP liegt mehr als ein Warenkorb-Formular: main-product rendert
  // zusaetzlich product-quick-buy (main-product.liquid:169), dazu kommen
  // Produktkacheln in Related Products. Ein Formular ist UNSERES, wenn seine
  // Varianten-id zu diesem Produkt gehoert -- alles andere duerfen wir weder
  // blockieren noch mit unseren Properties bestuecken.
  function istUnserFormular(f) {
    if (!f) return false;
    var idFeld = f.querySelector('[name="id"]');
    var vid = idFeld && String(idFeld.value || '');
    return !!(vid && VARIANTS[vid]);
  }

  function themeForm() {
    var alle = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < alle.length; i++) {
      if (istUnserFormular(alle[i])) return alle[i];
    }
    return null;
  }

  function setProp(f, name, value) {
    var feld = 'properties[' + name + ']';
    var input = f.querySelector('input[name="' + feld + '"][data-besties]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = feld;
      input.setAttribute('data-besties', '');
      f.appendChild(input);
    }
    input.value = value;
  }

  // --- Zeichensatz- und Wortsperrpruefung ----------------------------------
  // Was die Druckschrift nicht kann, darf nicht ins Feld: Emojis, kyrillische
  // oder asiatische Zeichen erscheinen im Druck als leere Kaestchen. Erlaubt
  // sind Basis-Latein inkl. Umlaute/ß, Ziffern, gaengige Satzzeichen, & und +.
  // Das ist NUR die UX-Vorwarnung -- die verbindliche Pruefung sitzt auf dem
  // Server (tools/besties-server-textcheck.py).
  var TEXT_ALLOWED = /^[A-Za-z0-9ÄÖÜäöüßÀ-ÿ .,!?'’&+\-()]*$/;
  // Der SPRUCH laeuft in Clash Display — die hat auch die polnischen
  // Glyphen (per Canvas-Breitenvergleich verifiziert, 09.08., Anlass:
  // Dominiks SISTERS-Shirt, Zwillingsschwester lebt in Polen). Die NAMEN
  // laufen in futura-pt, der diese Glyphen FEHLEN — deshalb zwei Listen,
  // nicht eine: polnische Namen wuerden im Ersatzfont gedruckt.
  var TEXT_ALLOWED_SPRUCH = /^[A-Za-z0-9ÄÖÜäöüßÀ-ÿĄąĆćĘęŁłŃńŚśŹźŻżĞğİıŞş .,!?'’&+\-()]*$/;
  // Die NAMEN laufen in futura-pt. Seit dem Subset-Wechsel des Adobe-Kits
  // auf "all" (09.08., Typekit-API) liefert die Schrift ihren vollen
  // Zeichensatz: Latin Extended (polnisch, tuerkisch) UND Kyrillisch —
  // offizielle Sprachliste von Paratype umfasst u.a. pl, tr, ru, uk.
  // KEIN Arabisch/Griechisch (hat die Schrift nicht).
  var TEXT_ALLOWED_NAMEN = /^[A-Za-z0-9ÄÖÜäöüßÀ-ÿĄąĆćĘęŁłŃńŚśŹźŻżĞğİıŞş\u0400-\u04FF .,!?'’&+\-()]*$/;
  // Platzhalter -- vor dem Live-Gang von Dominik zu befuellen (unternehmerische
  // und rechtliche Entscheidung). Mindestens: Beleidigungen, Sexuelles,
  // verfassungsfeindliche Begriffe, fremde Marken. Kleingeschrieben, weil die
  // Pruefung gegen s.toLowerCase() laeuft.
  var TEXT_BLOCKED = [];

  function checkText(value, feldname, muster) {
    var s = String(value || '');
    if (!(muster || TEXT_ALLOWED).test(s))
      return feldname + ' enthält Zeichen, die wir nicht drucken können. Bitte ohne Emojis und Sonderzeichen.';
    var low = s.toLowerCase();
    for (var w = 0; w < TEXT_BLOCKED.length; w++) {
      if (low.indexOf(TEXT_BLOCKED[w]) !== -1) return 'Diesen Text können wir leider nicht drucken.';
    }
    return null;
  }

  // --- Validierung ---------------------------------------------------------
  // Ein Shirt mit leerem Rahmen ist eine Reklamation mit Ansage.
  // opts.ohneVariante: fuer Statuszeile und Dialog -- dort geht es nur um die
  // Gestaltung, Farbe und Groesse waehlt der Kunde im Picker daneben.
  function validate(opts) {
    opts = opts || {};
    if (!state.count) return 'Bitte wähle zuerst die Anzahl der Fotos.';
    if (!opts.ohneVariante && !state.variant_id) {
      return state.size
        ? 'Diese Kombination aus Farbe und Größe ist leider nicht verfügbar.'
        : 'Bitte wähle eine Größe.';
    }
    // Erst zaehlen, dann melden. "Es fehlt noch Foto 2 von 8" nannte die
    // naechste Luecke und war dadurch verwirrend -- es klang nach einem
    // bestimmten Foto, gemeint war die Gesamtzahl. Dominik, 07.08.: "selbst
    // ich weiss nicht, was das heissen soll".
    var fehlen = 0;
    for (var f = 0; f < state.count; f++) {
      var pf = state.photos[f];
      if (!pf || !pf.url) fehlen++;
    }
    if (fehlen === state.count) return state.count === 1
      ? 'Wähle dein Foto aus.'
      : 'Wähle ' + state.count + ' Fotos aus.';
    if (fehlen === 1) return 'Es fehlt noch 1 Foto.';
    if (fehlen > 1) return 'Es fehlen noch ' + fehlen + ' von ' + state.count + ' Fotos.';

    for (var i = 0; i < state.count; i++) {
      var p = state.photos[i];
      if (p.pending === true) return 'Foto ' + (i + 1) + ' wird noch hochgeladen. Einen Moment bitte.';
      if (p.pending === 'error') return 'Foto ' + (i + 1) + ' konnte nicht hochgeladen werden. Bitte neu wählen.';
      // blob: und data: heissen beide: der S3-Upload ist nicht durch. Solche
      // URLs sind auf dem Render-Server tot, das Shirt kaeme leer aus dem Druck.
      if (/^(blob|data):/.test(p.url)) return 'Foto ' + (i + 1) + ' ist noch nicht fertig hochgeladen.';
      // Ohne Crop rechnet die Engine mit dem Vollbild, und object-fit:fill
      // verzerrt dann jedes Foto, dessen Seitenverhaeltnis nicht zufaellig passt.
      if (!p.crop || !(p.crop.w > 0) || !(p.crop.h > 0))
        return 'Foto ' + (i + 1) + ' ist noch nicht zugeschnitten. Bitte kurz warten oder neu wählen.';
    }
    if (!String(state.names || '').trim()) return 'Bitte tragt eure Namen ein.';
    // Laenge auch hier pruefen, nicht nur ueber maxLength am Eingabefeld:
    // das Attribut schuetzt die Eingabe, nicht den Zustand.
    if (String(state.names).length > P.maxNamesChars)
      return 'Die Namen dürfen höchstens ' + P.maxNamesChars + ' Zeichen lang sein.';
    if (state.title.mode === 'custom' && !String(state.title.value || '').trim())
      return 'Bitte gib deinen eigenen Titel ein oder wähle einen aus der Liste.';
    // Der Spruch wird genauso gedruckt wie der Titel. Leer heisst eine leere
    // Zeile auf dem Shirt, also derselbe Reklamationsfall wie ein leerer Rahmen.
    if (!String(state.quote || '').trim())
      return state.quoteMode === 'custom'
        ? 'Bitte gib deinen eigenen Spruch ein oder wähle einen aus der Liste.'
        : 'Bitte wähle einen Spruch aus.';
    // Laengencheck nur fuer den FREITEXT — Presets setzt die Redaktion.
    if (state.quoteMode === 'custom' && String(state.quote).length > MAX_QUOTE)
      return 'Der Spruch darf höchstens ' + MAX_QUOTE + ' Zeichen lang sein.';
    var textProblem =
      (state.title.mode === 'custom' ? checkText(state.title.value, 'Der Titel') : null) ||
      checkText(state.quote, 'Der Spruch', TEXT_ALLOWED_SPRUCH) ||
      checkText(state.names, 'Die Namen', TEXT_ALLOWED_NAMEN);
    if (textProblem) return textProblem;
    return null;
  }

  // --- Sichtbare Feld-Markierung (Ansage Dominik 09.08.) -------------------
  // validate() liefert den Satz fuer die Meldung unterm Knopf; hier zusaetzlich
  // WELCHE Felder fehlen, damit sie rot umrandet und beschriftet werden --
  // vorher scrollte der Klick nur nach oben und der Kunde sah nirgends, wo es
  // hakt. Nach dem ersten fehlgeschlagenen Kaufklick prueft jede Aenderung
  // die Markierungen erneut (Aufruf in repaint), damit sie live verschwinden.
  var fehlerAktiv = false;

  function fehlendeFelder() {
    var keys = [];
    if (!state.count) { keys.push('count'); return keys; }
    for (var i = 0; i < state.count; i++) {
      var p = state.photos[i];
      var kaputt = !p || !p.url || p.pending === true || p.pending === 'error' ||
        /^(blob|data):/.test(p.url) || !p.crop || !(p.crop.w > 0) || !(p.crop.h > 0);
      if (kaputt) keys.push('photo-' + i);
    }
    if (!String(state.names || '').trim() || String(state.names).length > P.maxNamesChars)
      keys.push('names');
    if (state.title.mode === 'custom' && !String(state.title.value || '').trim())
      keys.push('titel');
    if (!String(state.quote || '').trim()) keys.push('spruch');
    return keys;
  }

  function markiereFehler(scrollen) {
    fehlerAktiv = true;
    var keys = fehlendeFelder();
    var erster = null;
    var felder = document.querySelectorAll('#besties-form [data-feld]');
    for (var i = 0; i < felder.length; i++) {
      var el = felder[i];
      var fehlt = keys.indexOf(el.dataset.feld) !== -1;
      el.classList.toggle('besties-field--fehlt', fehlt);
      var hinweis = el.querySelector('.besties-feld-hinweis');
      if (fehlt) {
        if (!hinweis) {
          hinweis = h('span', 'besties-feld-hinweis', 'Dieses Feld wird benötigt');
          var label = el.querySelector('.besties-field__label');
          if (label && label.parentNode) label.parentNode.insertBefore(hinweis, label.nextSibling);
          else el.insertBefore(hinweis, el.firstChild);
        }
        if (!erster) erster = el;
      } else if (hinweis) {
        hinweis.remove();
      }
    }
    if (scrollen && erster && erster.scrollIntoView) {
      erster.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (!keys.length) fehlerAktiv = false;
    return keys.length;
  }

  // --- Warenkorb ueber das Theme-Formular ----------------------------------
  // Der Render-Aufruf muss VOR dem Absenden durch sein, weil erst er die
  // Druckdatei-URL liefert. Deshalb: Absenden abfangen, rendern, Felder
  // schreiben, dann erneut absenden. Die Signatur verhindert, dass der zweite
  // Durchlauf wieder abbiegt und wir uns im Kreis drehen.
  var vorbereitet = null;
  var imFlug = false;

  // Waehrend des Renders muessen die Kaufknoepfe gesperrt sein. Ohne das legt
  // ein zweiter Klick eine zweite Position in den Warenkorb: der Kunde zahlt
  // zwei Shirts, MerchOne druckt wegen quantity:1 aber nur eines.
  function sperreKaufen(f, an) {
    imFlug = an;
    var knoepfe = f.querySelectorAll('button[type="submit"], input[type="submit"]');
    for (var i = 0; i < knoepfe.length; i++) knoepfe[i].disabled = an;
  }

  function signatur() {
    return JSON.stringify([state.variant_id, window.BestiesEditor.getConfig()]);
  }

  // Sofort-Vorschau fuer den Warenkorb (Ansage Dominik 08.08.): Schnappschuss
  // der Stage in sessionStorage — der Drawer zeigt ihn ohne auf den
  // Server-Render zu warten (line-item.liquid liest kaCartPreview:<job>).
  // Fail-soft: ohne html2canvas oder bei CORS-Taint bleibt der Server-Weg.
  function stageSchnappschuss(jobId) {
    try {
      var st = stageEl();
      if (!st || typeof window.html2canvas !== 'function') return Promise.resolve();
      return window.html2canvas(st, {
        useCORS: true,
        backgroundColor: '#f6f6f6',
        scale: Math.min(1, 360 / Math.max(1, st.clientWidth)),
        logging: false,
      }).then(function (canvas) {
        sessionStorage.setItem('kaCartPreview:' + jobId, canvas.toDataURL('image/jpeg', 0.75));
      }).catch(function () {});
    } catch (e) { return Promise.resolve(); }
  }

  function vorbereitenUndSenden(f) {
    var jobId = crypto.randomUUID();
    var cfg = window.BestiesEditor.getConfig();

    // Der Render-Payload muss FLACH sein: die Server-View liest data.get('photos'),
    // data.get('print'), data.get('count') auf oberster Ebene und speichert den
    // kompletten Body als full_config_json. Ein verschachteltes config_json wird
    // nirgends ausgepackt.
    //
    // garment ist NICHT optional: der Server loest daraus ueber GARMENT_SKUS und
    // resolve_garment() die Druck-SKU auf und schreibt ein lesbares Label in
    // size_label. Eine unbekannte Kombination wird mit HTTP 400 abgelehnt statt
    // still mit leerer SKU durchzulaufen.
    var renderPayload = {
      job_id: jobId,
      product: 'besties',
      garment: {
        // Besties-Hoodie (08.08.): das Blank kommt aus dem Block-Markup —
        // gleiche Engine, Handle entscheidet (gildan-5000 | gildan-18500).
        blank: (document.querySelector('[data-besties-cta]') || { dataset: {} }).dataset.garmentBlank || 'gildan-5000',
        color: state.colorToken || state.theme,      // Gelato-Farbtoken
        size: String(state.size || '').toLowerCase() // 's'|'m'|'l'|'xl'|'xxl'
      },
      count: cfg.count, theme: cfg.theme, title: cfg.title,
      quote: cfg.quote, names: cfg.names, photos: cfg.photos,
      variant_id: state.variant_id,
      // 300 statt 150 dpi. MerchOnes Print-Area-Guide nennt 150 als MINIMUM
      // ("The minimum resolution for your image should be 150 dpi"), nicht als
      // Sollwert -- exakt an der Untergrenze zu liefern laesst keine Reserve.
      // MerchOne baut aus unserer Datei ohnehin einen Bogen mit 290 dpi, der
      // muss damit nicht mehr hochrechnen.
      // width_pixels/height_pixels sind nur informativ: der Server rechnet
      // width_inches * dpi (models.py:200), also 14 x 300 = 4200 und 16 x 300 = 4800.
      print: { width: 35.56, height: 40.64, width_pixels: 4200, height_pixels: 4800, dpi: 300 }
    };

    // Fallback-URL VORAB setzen, nur bei Erfolg ueberschreiben. Muster aus
    // foto-decke-collage.js:1762: der Server kann den Print spaeter aus den
    // gespeicherten Job-Daten rekonstruieren, falls der Render-Aufruf scheitert.
    // Ein leerer String haette keinen Weg mehr zum Render, die Bestellung ginge
    // aber trotzdem raus.
    var printImageUrl = API + '/api/v1/blanket/data/' + jobId + '/';

    sperreKaufen(f, true);

    // Schnappschuss laeuft PARALLEL zum Render-POST — beide sind vor dem
    // Submit fertig (zusammen ~0,5 s).
    var schnappschuss = stageSchnappschuss(jobId);

    fetch(API + '/api/v1/blanket/render/', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(renderPayload)
    })
      .then(function (r) {
        // Frueher wurde JEDER Fehlerstatus still zu {} und die Bestellung lief
        // durch: bezahlt, nie gedruckt, kein Alarm. Ein 400 heisst, der Server
        // hat die Konfiguration abgelehnt -- das darf nicht in den Warenkorb.
        if (r.ok || r.status === 202) return r.json().catch(function () { return {}; });
        return r.json().catch(function () { return {}; }).then(function (j) {
          var e = new Error(j && (j.error || j.detail) || ('HTTP ' + r.status));
          e.abgelehnt = true;
          throw e;
        });
      })
      .then(function (d) {
        if (d && d.print_image_url) printImageUrl = d.print_image_url;
        setProp(f, '_Provider', 'gelato');
        setProp(f, '_job_id', jobId);
        setProp(f, '_print_image_url', printImageUrl);
        // Cart-Vorschau: der Worker legt das Flatlay-Komposit unter dieser
        // vorhersagbaren URL ab (services._schreibe_cart_preview).
        setProp(f, '_preview_image_url', API + '/media/blanket_renders/' + jobId + '_cartpreview.jpg');
        setProp(f, '_config_json', JSON.stringify(cfg));
        setProp(f, '_Farbe', state.theme === 'black' ? 'Schwarz' : 'Weiß');
        setProp(f, '_Fotos', String(state.count));
        setProp(f, '_Titel', state.title.value);
        setProp(f, '_Namen', state.names);
        vorbereitet = signatur();
        return schnappschuss.then(function () {
          sperreKaufen(f, false);
        // requestSubmit statt submit: so laeuft der eigene Warenkorb-Ablauf des
        // Themes (Drawer, Zaehler) weiter. submit() wuerde ihn uebergehen.
        if (f.requestSubmit) f.requestSubmit(); else f.submit();
        // Direkt wieder entwerten: ein zweiter Klick soll einen NEUEN Job
        // rendern statt dieselbe job_id ein zweites Mal in den Warenkorb zu
        // legen -- MerchOne druckt pro Job nur einmal.
        vorbereitet = null;
        });
      })
      .catch(function (e) {
        sperreKaufen(f, false);
        console.error('[besties] Render abgelehnt', e);
        showError(e && e.abgelehnt
          ? 'Deine Gestaltung konnte nicht vorbereitet werden: ' + e.message +
            ' Bitte prüfe die Auswahl oder versuche es erneut.'
          : 'Die Verbindung zum Gestaltungs-Server hat nicht geklappt. Bitte versuche es noch einmal.');
        updateStatus();
        openDialog();
      });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    // NUR unser eigenes Formular. Auf der PDP liegen weitere Warenkorb-
    // Formulare (product-quick-buy, Produktkacheln in Related Products) --
    // die duerfen wir weder blockieren noch mit unseren Feldern bestuecken.
    // Im Harness nachgewiesen: ohne diese Zeile wurde das fremde Formular
    // stillschweigend am Absenden gehindert.
    if (!istUnserFormular(f)) return;
    // Letzte Rettung: steht die Variante immer noch nicht, hier aus dem
    // Formular ziehen -- zu diesem Zeitpunkt existiert es garantiert.
    if (!state.variant_id) applyVariant(initialVariant());
    var problem = validate();
    if (problem) {
      e.preventDefault();
      e.stopPropagation();
      updateStatus();
      // Fehlt die Gestaltung, hilft nur der Dialog. Fehlt die Groesse, steht
      // der Picker daneben -- dann NICHT aufreissen, das waere bevormundend.
      // Aber die Meldung MUSS sichtbar werden, sonst tut der Klick nichts.
      if (validate({ ohneVariante: true })) { openDialog(); showError(problem); markiereFehler(true); }
      else zeigeHinweisAmKnopf(problem);
      return;
    }
    if (vorbereitet === signatur()) return;   // zweiter Durchlauf, durchlassen
    e.preventDefault();
    e.stopPropagation();
    vorbereitenUndSenden(f);
  }, true);

  // --- Start ---------------------------------------------------------------
  initBlock();
})();
